<template>
    <div class="modal-overlay">
        <div class="content">
            <h1 class="title-error"> {{ titleModal }}</h1>
            <p class="message-error"> {{ messageError }}</p>
            <button class="btn btn-secondary" @click="$emit('fechar')">Fechar</button>
        </div>
    </div>
</template>


<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    titleModal: {
        type: String
    },
    messageError: {
        type: String
    }
})
</script>
